/**
 * Ledger Reconciliation Service - Frontend service for ledger reconciliation audit and apply
 */

import api from "@/shared/api";

/**
 * Get ledger reconciliation audit report
 * @param {Object} params - Query parameters
 * @param {string} params.since - ISO date string (default: ledger go-live date)
 * @param {number} params.sample - Sample size (default: 200, max: 1000)
 * @param {boolean} params.fullScan - Whether to do full scan (default: false)
 * @returns {Promise<Object>} Audit report
 */
export const getLedgerReconciliationAudit = async (params = {}) => {
  try {
    const response = await api.get("/ledger/admin/reconciliation/audit", { params });
    return {
      success: true,
      data: response.data || response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message,
    };
  }
};

/**
 * Apply HIGH confidence invoice→job links
 * @param {Object} params - Request parameters
 * @param {boolean} params.dryRun - Dry run mode (default: false)
 * @param {string} params.since - ISO date string (optional)
 * @returns {Promise<Object>} Apply result
 */
export const applyInvoiceJobLinks = async (params = {}) => {
  try {
    const response = await api.post("/ledger/admin/reconciliation/apply/invoice-job-links", {
      dryRun: params.dryRun || false,
      since: params.since || undefined,
    });
    return {
      success: true,
      data: response.data || response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message,
    };
  }
};

/**
 * Backfill missing ledger entries idempotently
 * @param {Object} params - Request parameters
 * @param {boolean} params.dryRun - Dry run mode (default: false)
 * @param {string} params.since - ISO date string (optional)
 * @returns {Promise<Object>} Backfill result
 */
export const backfillLedgerEntries = async (params = {}) => {
  try {
    const response = await api.post("/ledger/admin/reconciliation/apply/ledger-backfill", {
      dryRun: params.dryRun || false,
      since: params.since || undefined,
    });
    return {
      success: true,
      data: response.data || response,
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || error.message,
    };
  }
};
